<template>
	<div id="equipment" class="gcardfr" v-loading="loading">
		<ImportTarr :config='taconfig'></ImportTarr>
		<el-row :gutter="gutVal" class>
			<el-col :span="24">
				<el-button v-if="$isAdminType()" size="small" type="primary" icon="el-icon-pluss" @click="addTer">
					{{ $t("terminal.add_device") }}
				</el-button>
				<el-button v-if="$isAdminType()" size="small" type="primary" @click="addBcTer">{{ $t("app_mulAdd") }}
				</el-button>
				<el-button v-if="$isAdminType()" size="small" @click="ImportEquip">{{ $t("terminal.import_btn") }}
				</el-button>
				<el-button v-if="$isAdminType()" size="small" @click="importPd">{{ $t("terminal.pro_import") }}
				</el-button>
				<el-button v-if="$isAdminType() || $isNmAdminType()" size="small" @click="moveEQ" type plain>
					{{ $t("terminal.move_device") }}
				</el-button>
				<el-button v-if="$isAdminType()" size="small" @click="batchDel" :disabled="sRows.length == 0"
					type="danger" plain>{{ $t("app_delete_select") }}</el-button>
				<el-button v-if="$isAdminType() && showDelAll" size="small" @click="delAll" type="danger" plain>
					{{ $t("app_delete_all") }}
				</el-button>
				<el-button v-if="$isAdminType() || $isNmAdminType() || $isProdType()" size="small" @click="expEq">
					{{ $t("terminal.export_device") }}
				</el-button>
				<el-button v-if="$isAdminType() || $isNmAdminType()" size="small" @click="mdTArray">
					{{ $t("terminal.modify_triplet") }}</el-button>
				<el-button v-if="$isAdminType()" size="small" @click="open_import" type plain>{{ $t("terminal.up_smid")
				}}</el-button>
				<el-button size="small" @click="open_imports" type plain>{{ $t("terminal.Match") }}</el-button>
				<el-button size="small" @click="open_l" type plain>{{ $t("terminal.MatchList") }}</el-button>
			</el-col>
		</el-row>
		<el-row :gutter="gutVal" class="gtbtop">
			<el-col :offset="0" :span="6" ssshow="$isAdminType() || $isProdType()">
				<div class="glineflex">
					<div class="left_label">
						<label>{{ $t("terminal.app_distributor") }}：</label>
					</div>
					<div class="right_label">
						<Merchant style="width: 100%" :config="sortMc"></Merchant>
					</div>
				</div>
			</el-col>
			<el-col :span="6" oooffset="$isAdminType() || $isProdType()?0:5">
				<div class="glineflex">
					<div class="left_label">
						<label @click="hideClick">{{ $t("terminal.device_status") }}：</label>
					</div>
					<div class="right_label">
						<el-select :size="$ctrlSize" v-model="stVl" clearable style="width: 100%;"
							:placeholder="$t('app_select')" @change="searchEquip">
							<el-option v-for="item in $equipSts" :key="item.vl" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="glineflex">
					<div class="left_label">
						<label>&nbsp;&nbsp;{{ $t('terminal.device_model') }}：</label>
					</div>
					<div class="right_label">
						<el-select :size="$ctrlSize" v-model="model" clearable style="width: 100%;"
							:placeholder="$t('app_select')" @change="searchEquip">
							<el-option v-for="(item, index) in model_type_list" :key="index" :label="item.name"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="6" oooffset="$isAdminType() || $isProdType()?0:5">
				<div class="glineflex">
					<div class="left_label">
						<label>{{ $t("terminal.network_type") }}：</label>
					</div>
					<div class="right_label">
						<el-select :size="$ctrlSize" v-model="networkType" clearable style="width: 100%;"
							:placeholder="$t('app_select')" @change="searchEquip">
							<el-option v-for="(item, index) in networkType_list" :key="index" :label="item.name"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>

		</el-row>
		<el-row :gutter="gutVal" class="gtbtop">
			<el-col :span="6">
				<div class="glineflex">

					<div class="left_label">
						<label>&nbsp;&nbsp;{{ $t('app_search') }}：</label>
					</div>
					<div class="right_label" style="display: flex;align-items: center;">
						<el-input style="min-width: 70%;" size="small" v-model="srcEquip"
							@keyup.enter.native="searchEquip" :placeholder="$t('terminal.sn_or_name')">
						</el-input>

					</div>
				</div>
			</el-col>
			<el-checkbox v-model="isLike">
				{{ $t("app_blur") }}
			</el-checkbox>
		</el-row>
		<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" :data="tableData"
			@selection-change="batchSelected" @row-click="rowClick" @sort-change="sortChange" style="width: 100%">
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="deviceid" sortable="custom" :label="$t('terminal.device_sn')" width>
			</el-table-column>
			<!-- <el-table-column prop="devicename" :label="$t('terminal.device_name')" width></el-table-column> -->
			<el-table-column prop="productName" :label="$t('terminal.device_model_2')" width></el-table-column>
			<el-table-column prop="model" :label="$t('terminal.device_model')" width></el-table-column>
			<el-table-column prop="networkType" :label="$t('terminal.network_type')" width>
				<template slot-scope="scope">
					<span>{{ networkType_list_2[scope.row.networkType] }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="agentName" :label="$t('terminal.app_distributor')" width></el-table-column>
			<el-table-column prop="lineStatus" :label="$t('terminal.device_status')" width>
				<!-- <template slot-scope="scope">
          <div v-if='scope.row.bdStatus == 0' class='eqbs-ball-gray'></div>
          <div v-else class='eqbs-ball-green'></div>
          &nbsp;<label>{{$eqBindSt[scope.row.bdStatus + '']}}</label>
        </template>-->
			</el-table-column>
			<el-table-column prop="netsignal" sortable="netsignal" :label="$t('terminal.internet_signal')"
				width></el-table-column>
			<el-table-column prop="smid" :label="$t('terminal.smid')" width="150"></el-table-column>
			<el-table-column prop="isShare" align="center" :label="$t('terminal.isShare')" width>
				<template slot-scope="scope">
					<span v-if="scope.row.isShare == 1">{{ $t('terminal.yes') }}</span>
					<span v-if="scope.row.isShare == 2">{{ $t('terminal.Binding_failure') }}</span>
					<span v-if="scope.row.isShare == 0 || scope.row.isShare == null">{{ $t('terminal.no') }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="lastOnlineTime" :label="$t('terminal.last_online')" width="170"></el-table-column>
			<el-table-column :label="$t('app_operation')" width="120">
				<template slot-scope="scope">
					<el-button type="text" @click="toDetail(scope.row)">{{ $t("app_detail") }}</el-button>
					<!--<el-button type='text' :disabled="scop e.row.bdStatus==0? true:false" @click='unbind(scope.row)'>{{$eqBindOper[scope.row.bdStatus ==0? 0:1+ '']}}</el-button>-->
					<label v-if="!$isProdType()" class="opbline">|</label>
					<el-button :disabled="!$isAdminType()" @click="delRow(scope.row)" type="text" class="opdcolor">
						{{ $t("app_delete") }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>

		<el-dialog @close="closeProd" style="min-width: 1140px;" class="gstdia" :title="$t('terminal.pro_import')"
			:visible.sync="showpdip">
			<el-form :model="pdform" :rules="rules1" ref="ruleForm1" v-loading="dloading">
				<el-form-item :label="$t('terminal.order_number')" :label-width="$formlbWidth" prop="order">
					<el-input v-model="pdform.order" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop="mech">
					<Merchant :config="editMc"></Merchant>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_model')" :label-width="$formlbWidth" prop="mech">
					<el-select v-model="pdform.model" :placeholder="$t('app_select')" style="width: 100%;">
						<el-option v-for="(item, index) in model_type_list" :key="index" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('terminal.network_type')" :label-width="$formlbWidth" prop="type">
					<el-radio v-for="item in $nwtypes" :key="item.vl" v-model="pdform.type" :label="item.vl">
						{{ item.lb }}
					</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeProd()">{{ $t("app_cancel") }}</el-button>
				<el-button type="primary" @click="submitPd">{{ $t("app_sure") }}</el-button>
			</div>
		</el-dialog>


		<el-dialog @close="closeDiaBc" style="min-width: 1140px;" class="gstdia" :title="$t('terminal.ba_add_device')"
			:visible.sync="showDiaBc">
			<el-form :model="bcform" :rules="rules1" ref="ruleForm1" v-loading="dloading">
				<el-form-item :label="$t('terminal.device_model_2')" :label-width="$formlbWidth" prop="productkey">
					<Model :config="editModel"></Model>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_model')" :label-width="$formlbWidth" prop="model">
					<el-select v-model="bcform.model" :placeholder="$t('app_select')" style="width: 100%;">
						<el-option v-for="(item, index) in model_type_list" :key="index" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop="mech">
					<Merchant :config="editMc"></Merchant>
				</el-form-item>
				<el-form-item :label="$t('terminal.prefix')" :label-width="$formlbWidth" prop="fix">
					<el-input v-model="bcform.fix" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_nums')" :label-width="$formlbWidth" prop="num">
					<el-input-number @change="numChange" v-model="bcform.num" :min="1"></el-input-number>
				</el-form-item>
				<el-form-item :label="$t('terminal.start_to_end')" :label-width="$formlbWidth" prop="start">
					<el-input style="width: 180px;" @change="numChange" :disabled="!bcform.num" v-model="bcform.start">
					</el-input>
					&nbsp;&nbsp;~ &nbsp;&nbsp;{{ bcform.end }}
				</el-form-item>
				<el-form-item :label="$t('terminal.start_to_end')" :label-width="$formlbWidth" prop="skey">
					<el-input style="width: 70%;" :disabled="!bcform.isdy" v-model="bcform.skey" autocomplete="off">
					</el-input>&nbsp;&nbsp;
					<el-checkbox @change="checkChange" v-model="bcform.isdy">{{ $t("terminal.dynamic_key") }}
					</el-checkbox>
				</el-form-item>
				<el-form-item :label="$t('terminal.network_type')" :label-width="$formlbWidth" prop>
					<el-radio v-for="item in $nwtypes" :key="item.vl" v-model="bcform.ever" :label="item.vl">{{ item.lb
					}}
					</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDiaBc()">{{ $t("app_cancel") }}</el-button>
				<el-button type="primary" @click="submitBc">{{ $t("app_sure") }}</el-button>
			</div>
		</el-dialog>

		<el-dialog @close="closeDia" style="min-width: 1140px;" class="gstdia"
			:title="isEdit ? $t('terminal.edit_device') : $t('terminal.add_device')" :visible.sync="showDia">
			<el-form :model="tform" :rules="rules" ref="ruleForm" v-loading="dloading">
				<el-form-item :label="$t('terminal.device_sn')" :label-width="$formlbWidth" prop="deviceid">
					<el-input v-model="tform.deviceid" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_key')" :label-width="$formlbWidth" prop="devicesecret">
					<!-- <el-input v-model="tform.devicesecret" autocomplete="off"></el-input> -->
					<el-input style="width: 70%;" :disabled="!tform.isdy" v-model="tform.devicesecret"
						autocomplete="off"></el-input>&nbsp;&nbsp;
					<el-checkbox @change="checkChange1" v-model="tform.isdy">{{ $t("terminal.dynamic_key") }}
					</el-checkbox>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_model_2')" :label-width="$formlbWidth" prop="productKey">
					<Model :config="editModel"></Model>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_model')" :label-width="$formlbWidth" prop="productKey">
					<el-select v-model="tform.model" :placeholder="$t('app_select')" style="width: 100%;">
						<el-option v-for="(item, index) in model_type_list" :key="index" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('terminal.device_name')" :label-width="$formlbWidth" prop="devicename">
					<el-input v-model="tform.devicename" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop="merchant">
					<Merchant :config="editMc"></Merchant>
				</el-form-item>
				<el-form-item v-show="isEdit" :label="$t('terminal.volume')" :label-width="$formlbWidth">
					<el-row>
						<el-col :span="17">
							<el-row>
								<el-col :span="1">
									<img :src="icon_vdw" class="eqvlicon" />
								</el-col>
								<el-col :span="18" style="text-align: center">
									<el-slider v-model="tform.terminalVolume" style="width: 86%;margin-left: 7%;">
									</el-slider>
								</el-col>
								<el-col :span="5">
									<img :src="icon_vic" class="eqvlicon" />&nbsp;&nbsp;
									<label class="eqvltip">{{ tform.terminalVolume }}%</label>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="7" style="text-align: right;">
							<el-checkbox></el-checkbox>&nbsp;
							{{ $t("terminal.dynamic_key") }}
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item :label="$t('terminal.network_type')" :label-width="$formlbWidth" prop>
					<el-radio v-for="item in $nwtypes" :key="item.vl" v-model="tform.ver" :label="item.vl">{{ item.lb }}
					</el-radio>
				</el-form-item>
				<el-form-item :label="$t('terminal.platform')" :label-width="$formlbWidth" prop>
					<el-radio v-model="tform.type" label="0">{{ $t("terminal.default_platform") }}</el-radio>
					<el-radio v-model="tform.type" label="1">{{ $t("terminal.aliyun") }}</el-radio>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="submit">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">
      </div>-->
		</el-dialog>

		<ImportEquip :config="config"></ImportEquip>
		<ExportEq :config="eeconfig"></ExportEq>
		<EquipMove :config="emConfig"></EquipMove>



		<el-dialog class="gstdia" :title="$t('terminal.import_btn')" :visible.sync="show_import" @close='close_import'>
			<el-form :model="diaform" v-loading='loading' label-width="60px">
				<el-form-item label="">
					<div class='ipeqnum'>1</div>
					<div class='ipeqspl'></div>
					<div>
						<label slot="trigger" class='ipeqtt'>{{ $t('app_download_template') }}</label>
						<el-button slot="trigger" style="margin-left: 10px;" size="mini" type="primary"
							@click="downTempFile">
							<i class='el-icon-document'></i>
							{{ $t('app_download') }}
						</el-button>
					</div>
					<div class="el-upload__tip" style="font-size: 14px;">
						{{ $t('app_download_device_message') }}
					</div>
				</el-form-item>
				<el-form-item label="">
					<div class='ipeqnum'>2</div>
					<div>
						<el-upload class="upload-demo" ref="upload" name='file' :multiple='false' :action="saction"
							:before-upload='uploadBefore' :on-success="uploadSuccess" :on-change='uploadChange'
							:show-file-list='false' :auto-upload="false">
							<label slot="trigger" class='ipeqtt'>{{ $t('app_upload_template') }}</label>
							<el-button slot="trigger" style="margin-left: 10px;" size="mini" type="primary">
								<i class="el-icon-upload2"></i>
								{{ $t('app_upload') }}
							</el-button>
							<label slot="trigger" style="margin-left: 10px;">
								{{ cfile ? cfile.name : $t('app_unupload_file') }}
							</label>
							<div slot="tip" class="el-upload__tip" style="font-size: 14px;">
								{{ $t('app_upload_completed_device') }}
							</div>
						</el-upload>
					</div>
					<div>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button @click="show_import = false">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!ready" type="primary" @click="submitUpload">{{ $t('app_imp') }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog class="gstdia" :title="$t('app_import_result')" :visible.sync="showIpRs">
			<el-table tooltip-effect="dark" :data="importData" style="width: 100%">
				<el-table-column prop="msg" :label="$t('app_description')" width></el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog class="gstdia" :title="$t('terminal.Match')" :visible.sync="show_imports" @close='close_imports'>
			<el-form :model="diaform" v-loading='loading' label-width="60px">
				<el-form-item label="">
					<div class='ipeqnum'>1</div>
					<div class='ipeqspl'></div>
					<div>
						<label slot="trigger" class='ipeqtt'>{{ $t('app_download_template') }}</label>
						<el-button slot="trigger" style="margin-left: 10px;" size="mini" type="primary"
							@click="downTempFiles">
							<i class='el-icon-document'></i>
							{{ $t('app_download') }}
						</el-button>
					</div>
					<div class="el-upload__tip" style="font-size: 14px;">
						{{ $t('app_download_device_message') }}
					</div>
				</el-form-item>
				<el-form-item label="">
					<div class='ipeqnum'>2</div>
					<div>
						<el-upload :headers="headers" class="upload-demo" ref="uploads" name='file' :multiple='false'
							:action="sactions" :before-upload='uploadBefore' :on-success="uploadSuccess_i"
							:on-change='uploadChange_i' :show-file-list='false' :auto-upload="false">
							<label slot="trigger" class='ipeqtt'>{{ $t('app_upload_template') }}</label>
							<el-button slot="trigger" style="margin-left: 10px;" size="mini" type="primary">
								<i class="el-icon-upload2"></i>
								{{ $t('app_upload') }}
							</el-button>
							<label slot="trigger" style="margin-left: 10px;">
								{{ cfiles ? cfiles.name : $t('app_unupload_file') }}
							</label>
							<div slot="tip" class="el-upload__tip" style="font-size: 14px;">
								{{ $t('app_upload_completed_device') }}
							</div>
						</el-upload>
					</div>
					<div>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button @click="show_imports = false">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!readys" type="primary" @click="submitUploads">{{ $t('app_imp') }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


		<el-dialog class="gstdia" :title="$t('terminal.MatchList')" :visible.sync="showIpRs_i">
			<el-table tooltip-effect="dark" :data="tableDatas" style="width: 100%">
				<el-table-column prop="matchName" :label="$t('terminal.matchName')" width></el-table-column>
				<el-table-column prop="num" :label="$t('terminal.match_num')" width></el-table-column>
				<el-table-column prop="status" :label="$t('terminal.match_status')" width>
					<template slot-scope="scope">
						<span>{{ scope.row.status == 1 ? $t('terminal.match_s') : $t('terminal.match_e') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" :label="$t('terminal.match_createTime')" width></el-table-column>
				<el-table-column prop="updateTime" :label="$t('terminal.match_updateTime')" width></el-table-column>
				<el-table-column :label="$t('app_operation')" width="120">
					<template slot-scope="scope">
						<el-button type="text" @click="Downloads(scope.row)">{{ $t('app_download') }}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<Pages class="gpages" :cpage="pages" :ctotal="totals" :config="pconfigs"></Pages>
		</el-dialog>
	</div>
</template>

<style>
.eqvltip {
	color: rgba(0, 0, 0, 0.85);
}

.eqvlicon {
	width: 14px;
	height: 14px;
	margin: 0;
	padding: 0;
}

.eqbs-ball-green {
	width: 6px;
	height: 6px;
	display: inline-block;
	border-radius: 6px;
	overflow: hidden;
	background: rgba(82, 196, 26, 1);
}

.eqbs-ball-gray {
	width: 6px;
	height: 6px;
	display: inline-block;
	border-radius: 6px;
	overflow: hidden;
	background: rgba(191, 191, 191, 1);
}
</style>

<script>
import Pages from "@/components/Pages.vue";
import ImportEquip from "@/components/ImportEquip.vue";
import ImportTarr from "@/components/ImportTarr.vue";
import ExportEq from "@/components/ExportEq.vue";
import EquipMove from "@/components/EquipMove.vue";
import Merchant from "@/components/Merchant.vue";
import Model from "@/components/Model.vue";
import vic from "@/assets/eq_vlic.png";
import vdw from "@/assets/eq_vldw.png";
import axios from 'axios'

const dfkey = "UWN1NI8e58e0mdrPi9hk3AQxSvOVTgB3"
export default {
	data() {
		return {
			matchName: '',
			showIpRs_i: false,
			headers: {
				token: localStorage.token,
			},
			show_imports: false,
			saction: this.$eqImpAction(),
			sactions: this.$cardMatch(),
			cfile: {},
			cfiles: {},
			fwidth: "60px",
			showIpRs: false,
			importData: [],
			show_import: false,
			ready: false,
			readys: false,
			diaform: {},




			networkType_list: [{
				id: 1,
				name: "WIFI",
				value: 1,
			},
			{
				id: 2,
				name: "2G+WIFI",
				value: 2,
			},
			{
				id: 3,
				name: "4G+WIFI",
				value: 3,
			}, {
				id: 4,
				name: "4G",
				value: 4,
			},
			{
				id: 5,
				name: "2G",
				value: 5,
			}
			],
			networkType_list_2: ["NULL", "WIFI", "2G+WIFI", "4G+WIFI", "4G", "2G"],
			model_type_list: [{
				id: 0,
				name: "KS8303",
				value: "KS8303",
			},
			{
				id: 1,
				name: "ZTMD711",
				value: "ZTMD711",
			},
			{
				id: 2,
				name: "ZTMD715",
				value: "ZTMD715",
			},
			{
				id: 3,
				name: "KS8303 Plus",
				value: "KS8303 Plus",
			},
			{
				id: 4,
				name: "KS8303-R",
				value: "KS8303-R",
			}
			],
			sig: -100,
			sig1: 100,
			isLike: false,
			ssort: '',
			taconfig: {},
			pdform: {
				order: '',
				mech: '',
				model: "",
				type: '0'
			},
			showpdip: false,
			showDelAll: false,
			emConfig: "",
			eeconfig: {},
			sortMc: {},
			editMc: {},
			editModel: {},
			showDiaBc: false,
			isEdit: false,
			icon_vic: vic,
			icon_vdw: vdw,
			model: "",
			networkType: "",
			srcEquip: "",
			pconfig: "",
			pconfigs: "",
			tableData: [],
			tableDatas: [],
			showDia: false,
			ccount: 0,
			deviceUpdown: "",
			bcform: {
				mech: "",
				model: "",
				productkey: "",
				num: 1,
				start: "",
				end: "",
				skey: dfkey,
				isdy: false,
				fix: "",
				dfkey: dfkey,
				ever: '1'
			},
			tform: {
				deviceid: "",
				devicename: "",
				devicesecret: dfkey,
				agentId: "",
				isdy: false,
				dfkey: dfkey,
				volume: 50,
				productKey: "",
				produckName: "",
				bdStatus: 0,
				createTime: "",
				clientkey: "",
				merchant: "",
				type: "0",
				ver: '1'
			},
			page: 1,
			pages: 1,
			total: 0,
			totals: 0,
			loading: false,
			dloading: false,
			sRows: [],
			optionsProduct: [],
			config: "",
			rules: {
				deviceid: [{
					required: true,
					message: this.$t("app_input"),
					trigger: "blur"
				}],
				devicename: [{
					required: true,
					message: this.$t("app_input"),
					trigger: "blur"
				}],
				productKey: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				merchant: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				devicesecret: [{
					required: true,
					message: this.$t("app_input"),
					trigger: "blur"
				}]
			},
			rules1: {
				order: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				mech: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				model: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				productkey: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				skey: [{
					required: true,
					message: this.$t("app_input"),
					trigger: "blur"
				}],
				fix: [{
					required: true,
					message: this.$t("app_input"),
					trigger: "blur"
				}],
				type: [{
					required: true,
					message: this.$t("app_select"),
					trigger: "blur"
				}],
				num: [{
					type: "number",
					min: 1,
					required: true,
					message: this.$t("app_input_num"),
					trigger: "blur"
				}],
				start: [{
					pattern: /^\d*$/,
					required: true,
					message: this.$t("app_input_start"),
					trigger: "blur"
				}]
			},
			gutVal: 20,
			mcVl: "",
			stVl: ""
		};
	},
	components: {
		Pages,
		ImportEquip,
		Merchant,
		Model,
		EquipMove,
		ExportEq,
		ImportTarr
	},
	methods: {
		async Downloads(item) {
			// console.log('this.$exportMatch', this.$exportMatch)
			try {
				/* 1. 发 GET 请求，注意 responseType 必须设为 'blob' */
				const res = await axios.get(this.$exportMatch(), {
					params: { id: item.id },
					responseType: 'blob',
					headers: {
						token: localStorage.token,
					},
				})

				/* 2. 取出文件名（后端通过 Content-Disposition 返回） */
				let fileName = 'file'
				const disposition = res.headers['content-disposition']
				if (disposition) {
					const match = disposition.match(/filename\*?=([^;]+)/)
					if (match) fileName = decodeURIComponent(match[1].replace(/['"]/g, ''))
				}

				/* 3. 创建 <a> 标签触发下载 */
				const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
				if (window.navigator && window.navigator.msSaveOrOpenBlob) {
					// IE10/11
					window.navigator.msSaveOrOpenBlob(blob, fileName)
				} else {
					const url = window.URL.createObjectURL(blob)
					const link = document.createElement('a')
					link.href = url
					link.download = fileName
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
					window.URL.revokeObjectURL(url)
				}
				// this.$message.success('下载成功')
			} catch (e) {
				/* 4. 异常处理（兼容后端返回 JSON 错误） */
				if (e.response && e.response.data instanceof Blob) {
					const text = await e.response.data.text()
					try {
						const json = JSON.parse(text)
						this.$message.error(json.msg || '下载失败')
					} catch {
						this.$message.error('下载失败')
					}
				} else {
					this.$message.error(e.message || '下载失败')
				}
			} finally {
				// loading.close()
			}
		},
		getCardList() {
			this.$card_list(
				this.pages,
				this.$gRow,
				this.matchName,
				res => {
					if (res.status == 200) {
						this.totals = res.total;
						this.tableDatas = res.data;
					} else {
						this.$message.error(res.message);
					}
				},
				""
			);
		},
		open_l() {
			this.showIpRs_i = true
			this.getCardList()
		},
		close_imports() {
			this.show_imports = false;
			this.cfiles = {};
			this.readys = false;
			this.$refs.uploads.clearFiles()
			this.getList()
		},
		submitUploads() {
			this.loading = true
			this.$refs.uploads.submit()
		},
		uploadChange_i(file, fileList) {
			this.cfiles = file
			this.readys = file ? true : false
		},
		uploadSuccess_i(res, raw) {
			this.loading = false
			if (res.status == 200) {
				this.$message.success(res.message)
				this.close_imports()
			} else {
				this.$message.error(res.message)
			}
			// if (res.data.length > 0) {
			// 	this.importData = res.data;
			// 	this.showIpRs = true;
			// }
		},
		downTempFiles() {
			this.$exportTemplate()
		},
		open_imports() {
			this.show_imports = true;
		},
		close_import() {
			this.show_import = false;
			this.cfile = {};
			this.ready = false;
			this.$refs.upload.clearFiles()
			this.getList()
		},
		open_import() {
			this.show_import = true;
		},
		submitUpload() {
			this.loading = true
			this.$refs.upload.submit()
		},
		submitUpload() {
			this.loading = true
			this.$refs.upload.submit()
			// this.$refs.upload.submit();   clearFiles      
		},
		uploadChange(file, fileList) {
			this.cfile = file
			this.ready = file ? true : false
		},
		uploadBefore(file) {
			console.log('before', file)
		},
		uploadSuccess(res, raw) {
			this.loading = false
			if (res.status == 200) {
				this.$message.success(res.message)
				this.close_import()
			} else {
				this.$message.error(res.message)
			}
			if (res.data.length > 0) {
				this.importData = res.data;
				this.showIpRs = true;
			}
		},
		downTempFile() {
			this.$getDownFile()
		},





		ImportTa() {
			var _this = this;
			this.taconfig = {
				// pid: this.detail.id,
				showDia: true,
				callback: data => {
					_this.getList();
				}
			};
		},
		mdTArray() {
			this.ImportTa()
		},
		sortChange(obj) {
			console.log(obj)
			switch (obj.prop) {
				case "deviceid":
					this.ssort = "";
					if (obj.order == 'ascending') {
						this.deviceUpdown = 1;
					} else {
						this.deviceUpdown = 0;
					}
					break;
				case "netsignal":
					this.deviceUpdown = "";
					if (obj.order == 'ascending') {
						this.ssort = 1;
					} else {
						this.ssort = 0;
					}
					break;
				default:
					break;
			}
			this.searchEquip()
		},
		hideClick() {
			this.ccount++;
			if (this.ccount >= 6) {
				this.showDelAll = true;
			}
		},
		expEq() {
			var _this = this;
			this.eeconfig = {
				callback: () => {
					_this.getList();
				}
			};
		},
		moveEQ() {
			var _this = this;
			this.emConfig = {
				agid: "",
				showDia: true,
				callback: () => {
					_this.getList();
				}
			};
		},
		delAll() {
			this.$showMsgBox(
				this.$t("terminal.sure_delete_device"),
				() => {
					this.loading = true;
					var status = this.stVl ? this.stVl : "";
					var src = this.srcEquip ? this.srcEquip : "";
					var ag = this.mcVl;
					this.$delAllEq(
						ag,
						status,
						src,
						res => {
							this.loading = false;
							if (res.status == 200) {
								this.getList();
								this.$message.success(res.message);
							} else {
								this.$message.error(res.message);
							}
						},
						() => {
							this.loading = false;
						}
					);
				},
				""
			);
		},
		checkChange(is) {
			if (!is) {
				this.bcform.skey = this.bcform.dfkey;
			}
		},
		checkChange1(is) {
			if (!is) {
				this.tform.devicesecret = this.tform.dfkey;
			}
		},
		numChange(vl) {
			if ((vl || vl > 0) && this.bcform.start) {
				var pnum = parseInt(this.bcform.start);
				var slen = this.bcform.start.length;
				var end = pnum + this.bcform.num - 1 + "";
				var elen = end.length;
				if (slen - elen > 0) {
					//////// 结束位补0
					var len = slen - elen;
					for (var i = 0; i < len; i++) {
						end = "0" + end;
					}
				} else if (slen - elen < 0) {
					//////// 起始位补0
					var len = elen - slen;
					var start = this.bcform.start;
					for (var i = 0; i < len; i++) {
						start = "0" + start;
					}
					this.bcform.start = start;
				}
				this.bcform.end = end;
			}
		},
		batchDel() {
			this.$showMsgBox(
				this.$t("app_delete_question_2"),
				() => {
					var arr = [];
					this.sRows.forEach(item => {
						arr.push({
							deviceId: item.deviceid,
							productKey: item.productkey
						})
					});
					// {deviceId: deviceId, productKey: productKey}
					this.delRqs(arr);
				},
				""
			);
		},
		delRqs(pms) {
			this.loading = true;
			this.$aliDelEquip(
				pms,
				res => {
					this.loading = false;
					if (res.status == 200) {
						this.$message.success(res.message)
						this.getList();
					} else {
						this.$message.error(res.message);
					}
				},
				() => {
					this.loading = false;
				}
			);
		},
		delRow(item) {
			this.$showMsgBox(
				this.$t("app_delete_question"),
				() => {
					this.delRqs([{
						deviceId: item.deviceid,
						productKey: item.productkey
					}]);
				},
				""
			);
		},
		importPd() {
			this.showpdip = true;
			this.setMcCtr("");
		},
		addTer() {
			this.showDia = true;
			this.isEdit = false;
			this.setMcCtr("");
			this.setProCtr("");
		},
		addBcTer() {
			this.showDiaBc = true;
			this.setMcCtr("");
			this.setProCtr("");
		},
		toDetail(row) {
			this.$router.push({
				path: "/equipment/detail",
				query: {
					deviceid: row.deviceid,
					merchantId: row.merchantId
				}
			});
		},
		rowClick(row, column) {
			if (column.label != this.$t('app_operation')) {
				this.toDetail(row);
			}
		},
		getList() {

			this.loading = true;
			var deviceIdVal = this.srcEquip ? this.srcEquip : "";
			var agentIdVal = "";
			var merchantId = "";
			var agentIdSearch = this.mcVl;
			var status = this.stVl;
			var terType = "";
			this.$terList(
				this.page,
				this.$gRow,
				deviceIdVal,
				this.model,
				this.networkType,
				agentIdVal,
				merchantId,
				agentIdSearch,
				status,
				terType,
				this.sig,
				this.sig1,
				this.ssort,
				this.deviceUpdown,
				this.isLike ? 1 : 0,
				res => {
					this.loading = false;
					if (res.status == 200) {
						this.total = res.total;
						this.tableData = res.data;
						//console.log('equipment getList: '+JSON.stringify(res.data))
					} else {
						this.$message.error(res.message);
					}
				},
				""
			);
		},
		batchSelected(val) {
			this.sRows = val;
		},
		closeDia() {
			this.showDia = false;
			this.tform.deviceid = "";
			this.tform.productKey = "";
			this.tform.devicename = "";
			this.tform.model = "";
			this.tform.clientkey = "";
			this.tform.volume = 50;
			this.tform.devicesecret = this.tform.dfkey;
			this.tform.type = "0";
			this.tform.ver = '1';
			this.tform.isdy = false;
		},
		closeDiaBc() {
			this.showDiaBc = false;
			this.bcform = {
				mech: "",
				model: "",
				productkey: "",
				num: 1,
				start: "",
				end: "",
				skey: dfkey,
				isdy: false,
				fix: "",
				dfkey: dfkey,
				ever: '1'
			};
		},
		closeProd() {
			this.showpdip = false;
			this.pdform = {
				order: '',
				mech: '',
				model: "",
				type: '0'
			}
		},
		submit() {
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					this.okDia();
				}
			});
		},
		submitPd() {
			this.$refs["ruleForm1"].validate(valid => {
				if (valid) {
					this.plipRqs()
				}
			});
		},
		submitBc() {
			this.$refs["ruleForm1"].validate(valid => {
				if (valid) {
					this.okDiaBc();
				}
			});
		},
		plipRqs() {
			this.dloading = true;
			this.$importFromPl(this.pdform.order, this.pdform.mech, this.pdform.model, this.pdform.type, res => {
				this.dloading = false;
				if (res.status == 200) {
					this.closeProd();
					this.getList();
					this.$message.success(res.message);
				} else {
					this.$message.error(res.message);
				}
			}, () => {
				this.dloading = false;
			})
		},
		okDiaBc() {
			this.dloading = true;
			var fm = this.bcform;
			this.$batchAddEq(
				fm.fix,
				fm.productkey,
				fm.model,
				fm.num,
				fm.mech,
				fm.start,
				fm.end,
				fm.skey,
				fm.ever,
				res => {
					this.dloading = false;
					if (res.status == 200) {
						this.closeDiaBc();
						this.getList();
					} else {
						this.$message.error(res.message);
					}
				},
				() => {
					this.dloading = false;
				}
			);
		},
		okDia() {
			this.dloading = true;
			if (!this.isEdit) {
				if (this.tform.type == 0) {
					this.$addEquip(
						this.tform.deviceid,
						this.tform.productKey,
						this.tform.devicename,
						this.tform.model,
						this.tform.merchant,
						this.tform.volume,
						this.tform.devicesecret,
						this.tform.ver,
						res => {
							this.dloading = false;
							if (res.status == 200) {
								this.closeDia();
								this.getList();
							} else {
								this.$message.error(res.message);
							}
						},
						() => {
							this.dloading = false;
						}
					);
				} else {
					this.$aliAddEquip(
						this.tform.deviceid,
						this.tform.productKey,
						this.tform.devicename,
						this.tform.model,
						this.tform.merchant,
						this.tform.volume,
						this.tform.devicesecret,
						this.tform.ver,
						res => {
							this.dloading = false;
							if (res.status == 200) {
								this.closeDia();
								this.getList();
							} else {
								this.$message.error(res.message);
							}
						},
						() => {
							this.dloading = false;
						}
					);
				}
			} else {
				this.$editDeveloper(
					this.tform.id,
					this.tform.productKey,
					this.tform.accessid,
					this.tform.accesskey,
					this.tform.name,
					this.tform.phone,
					this.tform.email,
					this.tform.address,
					this.tform.enable,
					res => {
						this.dloading = false;
						if (res.status == 200) {
							this.closeDia();
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.dloading = false;
					}
				);
			}
		},
		srcbf() {
			if (this.sig <= this.sig1) {
				this.searchEquip()
			} else {
				this.$message.error(this.$t("app_rnage_error"))
			}
		},
		searchEquip() {
			this.page = 1;
			this.getList();
		},
		ImportEquip() {
			var _this = this;
			this.config = {
				type: 0, //// 0.equipement 1.agent 2.upgradedetail 3.merchant
				agid: "",
				showDia: true,
				callback: () => {
					_this.getList();
				}
			};
		},
		unbind(row) {
			this.$showMsgBox(
				this.$t("terminal.sure_unbind") + row.deviceid + "?",
				() => {
					this.unbindRqs(row.deviceid);
				},
				""
			);
		},
		unbindRqs(deviceid) {
			this.$unbindMerch(
				deviceid,
				res => {
					if (res.status == 200) {
						this.getList();
					} else {
						this.$message.error(res.message);
					}
				},
				""
			);
		},
		setMcCtr(vl) {
			var _this = this;
			this.editMc = {
				// type:'0',
				size: "",
				vlkey: "clientKey",
				value: vl ? vl : "",
				callback: vl => {
					if (this.showpdip) {
						_this.pdform.mech = vl;
					} else if (this.showDia) {
						_this.tform.merchant = vl;
					} else {
						_this.bcform.mech = vl;
					}
				}
			};
		},
		setProCtr(vl) {
			var _this = this;
			this.editModel = {
				size: "middle",
				isbatch: false,
				value: vl ? vl : "",
				callback: vl => {
					if (this.showDia) {
						_this.tform.productKey = vl;
					} else {
						_this.bcform.productkey = vl;
					}
				}
			};
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			var cpage = 1
			if (from.path == '/equipment/detail') {
				///rec 
				vm.$pmStore('get', 'equipment', ['page', 'mcVl', 'stVl', 'sig', 'sig1', 'srcEquip'], vm, (
					json) => {
					////控件还原          
					vm.sortMc = {
						size: "small",
						value: json['mcVl'],
						callback: vl => {
							vm.mcVl = vl ? vl : ""
							vm.searchEquip()
						}
					}
					cpage = json['page']
				})
			}
			//// 把 mounted get移到这里      
			vm.pconfig = {
				page: cpage,
				pname: "equip",
				callback: (page, size) => {
					vm.$gRow = size ? size : vm.$gRow;
					vm.page = page
					vm.getList()
				}
			}
			vm.pconfigs = {
				page: cpage,
				pname: "equip",
				callback: (page, size) => {
					vm.$gRow = size ? size : vm.$gRow;
					vm.pages = page
					vm.getCardList()
				}
			}
			vm.getList()
		})
	},
	beforeRouteLeave(to, from, next) {
		var keys = ['page', 'mcVl', 'stVl', 'sig', 'sig1', 'srcEquip']
		if (to.path == '/equipment/detail') {
			///save
			this.$pmStore('set', 'equipment', keys, this)
		} else {
			///clear
			this.$pmStore('set', 'equipment', keys, this)
		}
		next()
	},
	mounted() {
		var _this = this;

		this.$testak(res => {

		}, '')

		this.sortMc = {
			size: "small",
			value: "",
			callback: vl => {
				_this.mcVl = vl ? vl : ""
				_this.searchEquip();
			}
		}

		/*    this.editMc = {
		  size: '',
		  value: '',
		  callback: (vl) => {
			this.tform.clientkey = vl
		  }
		}
		this.editModel = {
		  size: '',
		  value: '',
		  callback: (vl) => {
			this.tform.type = vl
			this.tform.productkey = vl
		  }
		}*/
	}
};
</script>


<style scoped>
.left_label {
	width: 30%;
	min-width: 80px;
	font-size: 14px;
}

.right_label {
	width: 70%;
}
</style>
<style scoped>
.ipeqnum {
	width: 32px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	position: absolute;
	border: 1px solid rgba(0, 0, 0, 0.15);
	color: rgba(0, 0, 0, 0.25);
	font-weight: 400;
	left: -48px;
	border-radius: 32px;
}

.ipeqspl {
	height: 34px;
	width: 1px;
	left: -32px;
	top: 55px;
	position: absolute;
	background: rgba(0, 0, 0, 0.15);
}

.ipeqspl1 {
	height: 34px;
	width: 1px;
	left: -32px;
	top: -55px;
	position: absolute;
	background: rgba(0, 0, 0, 0.15);
}

.ipeqspl2 {
	height: 17px;
	width: 1px;
	left: -32px;
	top: -22px;
	position: absolute;
	background: rgba(0, 0, 0, 0.15);
}

.ipeqtt {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.85);
}
</style>